import { Checkbox, Flex, Link, Stack, Text } from '@chakra-ui/react'
import CustomTooltip from 'brokertslib/src/components/CustomTooltip'
import { useFormContext } from 'react-hook-form'

import { LabelHintIcon } from '@/icons'

export const BaScoringCheckbox = ({
  isContracted,
  name,
}: {
  isContracted: boolean
  name: string
}) => {
  const { getValues, setValue } = useFormContext()

  return (
    <Flex gap={2}>
      <Checkbox
        defaultChecked={getValues(name)}
        value="1"
        isDisabled={isContracted}
        onChange={(e) => setValue(name, e.target.checked)}
      >
        BA Skóring
      </Checkbox>
      <CustomTooltip
        hasArrow
        trigger="clickHover"
        boxProps={{ cursor: 'pointer' }}
        label={
          <Stack maxW="md">
            <Text>
              Zákazník uděluje pojistiteli souhlas s tím, že jeho osobní údaje
              budou automatizovaně zpracovány a zanalyzovány, včetně
              profilování, za účelem co nejvhodnějšího nastavení parametrů
              pojistné smlouvy. Na základě vyhodnocení získaných údajů může
              pojistitel poskytnout slevu na pojistném. Za tímto účelem mohou
              být údaje předány pojistiteli ze strany členů skupiny ČSOB, k
              čemuž zákazník vyslovuje souhlas.
            </Text>
            <Text>
              Mezi osobní údaje, které mohou být předmětem zpracování na základě
              tohoto souhlasu, patří zejména údaje o ekonomické situaci,
              osobních preferencích, zájmech, spolehlivosti, chování nebo
              souhrnné údaje o finančních transakcích (např. průměrná výše
              příjmů, výdajů a zůstatků).
            </Text>
            <Text>
              Informace o zpracování údajů, které obsahují zejména práva
              vztahující se ke zpracování údajů včetně práva na přístup k
              informacím a podmínky na ochranu práv, jsou k dispozici na{' '}
              <Link href="https://www.csob.cz/osobni-udaje" target="_blank">
                www.csob.cz/osobni-udaje
              </Link>
              .
            </Text>
            <Text>
              Aktuální seznam členů skupiny ČSOB je k dispozici na{' '}
              <Link href="https://www.csob.cz/skupina" target="_blank">
                www.csob.cz/skupina
              </Link>
              .
            </Text>
          </Stack>
        }
      >
        <LabelHintIcon width={4} height={4} />
      </CustomTooltip>
    </Flex>
  )
}
